class DefaultControllerConst {
    static Global = 'global';
    static Inner = 'inner';
}
export default DefaultControllerConst;